module.exports = (that) => {
	// 头部栏
	that.component('head-bar', () => import('@/components/headBar.vue'));
	// 各个页面的banner
	that.component('Banner', () => import('@/components/Banner.vue'));
	// 阅读更多
	that.component('read-more', () => import('@/components/readMore.vue'));
	// 下拉显示
	that.component('drop-down', () => import('@/components/dropDown.vue'));
	
	
	// 状态切换栏
	that.component('nav-bar', () => import('@/components/navBar.vue'));
	// 分页
	that.component('Paging', () => import('@/components/Paging.vue'));
	// 图片，可放大
	that.component('OImage', () => import('@/components/OImage.vue'));
	// 切换栏
	that.component('switch-bar', () => import('@/components/SwitchBar.vue'));
	// // 轮播图
	// that.component('swiper', () => import('@/components/swiper.vue'));
	that.component('PropContent', () => import('@/components/CustomLabel/PropContent.vue'));
	that.component('SwitchBtn', () => import('@/components/CustomLabel/SwitchBtn.vue'));
	
	// 按钮：
	that.component('Props', () => import('@/components/Props.vue'));
	
	// 按钮：
	that.component('rightIcon', () => import('@/components/rightIcon.vue'));
}



// WEBPACK FOOTER //
// ./src/components/AComponents.js